import { render, staticRenderFns } from "./AppArrow.vue?vue&type=template&id=61bf044f&scoped=true&"
import script from "./AppArrow.vue?vue&type=script&lang=js&"
export * from "./AppArrow.vue?vue&type=script&lang=js&"
import style0 from "./AppArrow.vue?vue&type=style&index=0&id=61bf044f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bf044f",
  null
  
)

component.options.__file = "AppArrow.vue"
export default component.exports